// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e3737ef8","455":"c0b90639","977":"97554ac9"}[chunkId] + ".chunk.js";
};